import * as React from "react";
import { SvgProps } from "../../types";

const DownArrow = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={8}
    fill="none"
    {...props}>
    <path
      fill="#999B9D"
      d="m5 7.083-5-5L1.167.917 5 4.75 8.833.917 10 2.083l-5 5Z"
    />
  </svg>
);
export default DownArrow;
